import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const TemplateFilterTags = props => {
  const { templatesStatusFilters, removeFilter, statuses } = props;
  return (
    <div className="temp-filter-tag-container">
      {templatesStatusFilters.map(item => (
        <div className="temp-filter-tag-pill">
          {statuses[item].label}
          <FontAwesomeIcon
            icon={["far", "times"]}
            className="temp-filter-tag-icon"
            onClick={() => removeFilter(item)}
          />
        </div>
      ))}
    </div>
  );
};

export default TemplateFilterTags;
